export default class bcSubscriptionCard {
	constructor($module) {
		this.$module = $module;
		this.$module = $module;
		const manageSubscription = document.querySelectorAll(".bc-subscription-card__manage");
		const manageSubscriptionList = document.querySelector(".bc-subscription-card__manage-list");
		
	
		manageSubscription.forEach(function (buttonClick){
			buttonClick.addEventListener('click', function () {
				const manageSubscriptionList = this.nextSibling;
				manageSubscriptionList.classList.toggle("bc-subscription-card__active");
				this.classList.toggle("bc-subscription-card__manage__active");
			});
		});
	}
}
